import TopHeader from './TopHeader';
import {
    BoxBelowTopHeader,
    ContentBox,
    ContentContainer,
    PageLayoutWrapperBox,
} from './CandidatePageLayout.styles';
import { ReactNode, useEffect } from 'react';
import { useAppDispatch } from '../../base';
import { organizationActions } from '../../actions';

interface ICandidatePageLayoutProps {
    children: ReactNode;
}
const CandidatePageLayout = (props: ICandidatePageLayoutProps) => {
    const { children } = props;

    const dispatch = useAppDispatch();

    const companyKey = new URLSearchParams(location.search).get('ck');

    useEffect(() => {
        if (companyKey) {
            dispatch(organizationActions.fetchCompanyInfo({ companyKey }));
        }
    }, [dispatch, companyKey]);

    return (
        <PageLayoutWrapperBox>
            <TopHeader />
            <BoxBelowTopHeader>
                <ContentBox>
                    <ContentContainer>{children}</ContentContainer>
                </ContentBox>
            </BoxBelowTopHeader>
        </PageLayoutWrapperBox>
    );
};

export default CandidatePageLayout;
